import { useEffect, useState } from 'react'
import useSWR from 'swr'

import { fetcher } from '@/lib/fetcher'

export type AgentSummary = {
  agent: string
  open_tasks: number
  hitl_pending: number
  event_count: number
  workflow: Record<string, unknown>
}

type UseMasterAgentsOptions = {
  enabled?: boolean
}

export function useMasterAgents({ enabled = true }: UseMasterAgentsOptions = {}) {
  const [available, setAvailable] = useState(true)

  useEffect(() => {
    setAvailable(Boolean(enabled))
  }, [enabled])

  const shouldFetch = enabled && available

  const { data, error, isLoading, mutate } = useSWR<{ agents: AgentSummary[] }>(
    shouldFetch ? '/master/agents' : null,
    fetcher,
    {
      refreshInterval: shouldFetch ? 10000 : 0,
      revalidateOnFocus: shouldFetch,
      onError: (err) => {
        if ((err as { status?: number } | undefined)?.status === 404) {
          setAvailable(false)
        }
      },
    },
  )

  return {
    agents: data?.agents ?? [],
    loading: shouldFetch ? Boolean(isLoading) : false,
    error: shouldFetch ? error : null,
    refresh: mutate,
    available: enabled && available,
  }
}
